/* istanbul ignore file */
import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import useTranslation from "../../../hooks/use-translation";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const styles = {
  cancelButton: {
    fontFamily: "JioType-Medium",
    color: "#333333",
    fontSize: "16px",
    width: "150px",
    alignSelf: "center",
    outline: "none",
    height: "42px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "0.5px solid #666666",
    borderRadius: "8px",
  },
  buttonDisabled: {
    textTransform: "none",
    height: "42px",
    width: "150px",
    border: "none",
    backgroundColor: "#93BED8",
    color: "#ffffff",
    fontSize: "16px",
    fontFamily: "jioType-Medium",
    outline: "none",
  },
  actionButton: {
    fontFamily: "JioType-Medium",
    color: "#FFFFFF",
    fontSize: "16px",
    width: "150px",
    alignSelf: "center",
    outline: "none",
    height: "42px",
    border: "none",
    background: "#3CB5EA 0% 0% no-repeat padding-box",
    borderRadius: "8px",
  },
  cancelAppointment: {
    margin: "40px auto 27px",
    color: "#333333",
    fontSize: "22px",
  },
  subHeader: {
    fontSize: "16px",
    color: "#333333",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    padding: "34px 0px 40px 0px",
  },
  popupContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
};
const CancelAppointment = (props) => {
  const {
    open = false,
    handleDialogOk,
    handleCancel,
    errorMessage = "",
  } = props;
  const { t } = useTranslation();

  const handleOkButton = async () => {
    handleDialogOk();
  };

  const handleCancelButton = () => {
    handleCancel();
  };

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="dialog-title"
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            marginLeft: "22px",
            marginRight: "22px",
            width: "28.125em",
            background: "#f6f6f6 0% 0% no-repeat padding-box",
            boxShadow: "16px 0px 24px #00000029",
            borderRadius: "0.625em",
          },
        }}
      >
        <div style={styles.popupContainer}>
          <div style={styles.cancelAppointment}>{t("CANCEL_APPOINTMENT")}</div>
          <div style={styles.subHeader}>{t("ARE_YOU_SURE_TEXT")}</div>
        </div>
        <div style={styles.buttonContainer}>
          <button style={styles.cancelButton} onClick={handleCancelButton}>
            <span>{t("NO")}</span>
          </button>
          <button style={styles.actionButton} onClick={handleOkButton}>
            <span>{t("YES")}</span>
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default CancelAppointment;
